import { chain } from 'lodash';
import * as yup from 'yup';
import { loginErrorMessage } from '~/utils/constants';

// const alphabetNumberRegex = /^[0-9A-Za-z]+$/;

export const loginValidation = yup.object({
  username: yup.string().required(loginErrorMessage.emptyAccount),
  // .matches(alphabetNumberRegex, loginErrorMessage.invalidFormat),
  password: yup.string().required(loginErrorMessage.emptyPassword),
  // .matches(alphabetNumberRegex, loginErrorMessage.invalidFormat),
  isRememberUsername: yup.boolean(),
});

export const FormSchema = yup.object({
  category: yup.array().min(1, '此欄位為必填欄位'),
  years: yup.array().min(1, '此欄位為必填欄位'),
  eduCodes: yup.array().min(1, '此欄位為必填欄位'),
  subjects: yup.array().min(1, '此欄位為必填欄位'),
  grades: yup.array().min(1, '此欄位為必填欄位'),
  resources1: yup.array().min(1, '此欄位為必填欄位'),
  resources2: yup.array().min(1, '此欄位為必填欄位'),
  urlName: yup.string().required('此欄位為必填欄位'),
  url: yup.string().required('此欄位為必填欄位'),
});

export const aiSettingValidation = yup.object({
  resourceConfigs: yup
    .array()
    .of(
      yup.object({
        eduCode: yup.string().required('必須選擇科目與資源類型'),
        subject: yup.string().required('必須選擇科目與資源類型'),
        grade: yup.string().required('必須選擇科目與資源類型'),
        resources1: yup.array().min(1, '必須選擇科目與資源類型'),
      }),
    )
    .test('unique', '', (value, ctx) => {
      if (value) {
        const newValue = value.map(
          item => item.eduCode + item.subject + item.grade,
        );
        const duplication = chain(newValue)
          .reduce(
            (
              acc: Record<string, { count: number; indices: number[] }>,
              item,
              index,
            ) => {
              acc[item] = acc[item] || { count: 0, indices: [] };
              acc[item].count += 1;
              acc[item].indices.push(index);
              return acc;
            },
            {},
          )
          .toPairs()
          .filter(([, _value]) => _value.count > 1)
          .flatMap(([, _value]) => _value.indices)
          .value();

        return duplication.length > 1
          ? ctx.createError({
              path: `resourceConfigs.${duplication[1]}.duplicated`,
              message: '「學制年級科目」組合重複',
            })
          : true;
      } else {
        return true;
      }
    }),
});
